import React, { FC } from 'react'
import { Box } from '@revolut/ui-kit'
import styled from 'styled-components'

import { currencies } from 'constants/currencies'
import { SizeMap, ScaleMap, CountryCodeShift } from './constants'

type Size = 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

type RoundFlagProps = {
  size: Size
  currency?: string
  code?: string
}

const Flag = styled(Box)``

const FlagBox = styled(Box)<{ code: string; size: Size }>`
  min-width: ${(props) => SizeMap[props.size as Size]};
  min-height: ${(props) => SizeMap[props.size as Size]};
  position: relative;
  ${Flag} {
    width: 3rem;
    height: 3rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(${(props) => ScaleMap[props.size as Size]});
    background-image: url('/ui/icons/flag-icons-sprite.png'),
      url('/icons/flag-icons-sprite.png');
    background-position: 0px -${(props) => CountryCodeShift[props.code.toLowerCase()]}px;
    background-repeat: no-repeat;
    border-radius: 50%;
  }
`

export const RoundFlag: FC<RoundFlagProps> = ({ size = 'sm', currency, code }) => {
  const countryCode =
    currency && currencies[currency] ? currencies[currency].country : code

  if (!countryCode) {
    return null
  }

  return (
    <FlagBox size={size} code={countryCode}>
      <Flag />
    </FlagBox>
  )
}
